import * as React from "react";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import { Link } from "react-router-dom";

import LoadingWidget from "../common/LoadingWidget";
import ProfileLink from "../common/ProfileLink";

import { Contact, Business, SimpleCustomer } from "../../model/Customer";
import { CustomerStore } from "../../stores/CustomerStore";

import Overview from "./Overview";
import BasicInformation from "./BasicInformation";
import CustomerAccount from "./CustomerAccount";
import AgentAuthorization from "./AgentAuthorization";
import CreditApplication from "./CreditApplication";
import Insurance from "./Insurance";
import Involvement from "./Involvement";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt, faBriefcase, faFlag } from "@fortawesome/free-solid-svg-icons";

import "./CustomerProfile.css";

export interface Props {
    customerStore?: CustomerStore;
    currentTab: string;
}
export interface State {}

@inject("customerStore")
@observer
export default class CustomerProfile extends React.Component<Props, State> {
    state: State = {};

    componentDidMount() {
        this.props.customerStore!.refresh();
    }

    render() {
        const { customerStore } = this.props!;
        if (!customerStore) {
            throw new Error(" ** No Customer Store **");
        }

        const customer = customerStore.customer;
        if (!customer) {
            return <div />;
        }

        const customerId = customer.id;

        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active">
                            <Link to="/customers">Customers</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Customer Profile
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-12">
                            <h1>
                                <span>
                                    {customer.type === "CONTACT" ? (
                                        <FontAwesomeIcon icon={faUserAlt} size="2x" className="mr-2 color-info" />
                                    ) : (
                                        <FontAwesomeIcon icon={faBriefcase} size="2x" className="mr-2 color-info" />
                                    )}
                                </span>
                                {customer.type === "CONTACT" && `${(customer as Contact).firstName} ${(customer as Contact).lastName}`}
                                {customer.type === "BUSINESS" && `${(customer as Business).businessName}`}
                                {customer.flaggedNotes && <FontAwesomeIcon icon={faFlag} className="mr-2 flagged" />}
                            </h1>
                            {this.props.customerStore!.loading && (
                                <div className="pull-right">
                                    <LoadingWidget />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-lg-3 col-xl-2">
                            <div className="card shadow">
                                <div className="card-header">Profile Menu</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul>
                                        <ProfileLink
                                            label="Overview"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="overview"
                                            active={this.props.currentTab === "overview"}
                                        />
                                        <ProfileLink
                                            label="Basic Information"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="basic-information"
                                            active={this.props.currentTab === "basic-information"}
                                        />
                                        <ProfileLink
                                            label="Customer Account"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="customer-account"
                                            active={this.props.currentTab === "customer-account"}
                                        />
                                        <ProfileLink
                                            label="Agent Authorization"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="agent-authorization"
                                            active={this.props.currentTab === "agent-authorization"}
                                        />
                                        <ProfileLink
                                            label="Credit Application"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="credit-application"
                                            active={this.props.currentTab === "credit-application"}
                                        />
                                        <ProfileLink
                                            label="Insurance"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="insurance"
                                            active={this.props.currentTab === "insurance"}
                                        />
                                        <ProfileLink
                                            label="Involvement"
                                            type={"customer"}
                                            numberId={customerId}
                                            page="involvement"
                                            active={this.props.currentTab === "involvement"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="col-md-9 col-lg-9 col-xl-10">
                            {this.props.currentTab === "overview" && <Overview />}
                            {this.props.currentTab === "basic-information" && <BasicInformation />}
                            {this.props.currentTab === "customer-account" && <CustomerAccount />}
                            {this.props.currentTab === "agent-authorization" && <AgentAuthorization />}
                            {this.props.currentTab === "credit-application" && <CreditApplication />}
                            {this.props.currentTab === "insurance" && <Insurance />}
                            {this.props.currentTab === "involvement" && <Involvement />}
                        </div>
                    </div>
                </div>
                {this.props.customerStore!.loading ? <LoadingWidget /> : ""}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/CustomerProfile.tsx